<script setup>
import { computed } from "vue";

const props = defineProps({
  invoice: {
    type: Object,
    required: true,
  },
});

const balance = computed(
  () => (props.invoice.totalAmount || 0) - (props.invoice.paidAmount || 0),
);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปการเงิน</h5>
          <div class="text-muted small">
            ยอดเรียกเก็บ ยอดรับชำระ และยอดคงเหลือ
          </div>
        </div>
        <div class="icon-box bg-warning-subtle text-warning">
          <i class="bi bi-wallet2"></i>
        </div>
      </div>

      <div class="summary-box bg-light rounded-4 p-3 mb-3">
        <div class="text-muted small mb-1">ยอดสุทธิทั้งสิ้น</div>
        <div class="fw-bold fs-4">
          {{ formatCurrency(invoice.totalAmount) }}
        </div>
      </div>

      <div class="summary-box bg-success bg-opacity-10 rounded-4 p-3 mb-3">
        <div class="text-muted small mb-1">ยอดที่ชำระแล้ว</div>
        <div class="fw-bold fs-4 text-success">
          {{ formatCurrency(invoice.paidAmount) }}
        </div>
      </div>

      <div
        class="summary-box rounded-4 p-3 mb-4"
        :class="
          balance > 0 ? 'bg-danger bg-opacity-10' : 'bg-success bg-opacity-10'
        "
      >
        <div class="text-muted small mb-1">ยอดคงเหลือ</div>
        <div
          class="fw-bold fs-4"
          :class="balance > 0 ? 'text-danger' : 'text-success'"
        >
          {{ formatCurrency(balance) }}
        </div>
      </div>

      <div class="vstack gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ค่าส่วนกลาง</span>
          <span class="fw-semibold">{{ formatCurrency(invoice.amount) }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ค่าปรับ</span>
          <span class="fw-semibold">{{ formatCurrency(invoice.penalty) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.icon-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
</style>
